module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"upgradeProject":"升级@:common.project","unlockProject":"解锁@:common.project","upgradeHint":"升级为永久@:common.project可以保证链接长期有效，解除付费阅读、更新PPT等限制","unlockHint":"解除@:common.project无法更新PPT的限制","upgradeComplete":"该@:common.project已成功升级为永久@:common.project！","unlockComplete":"该@:common.project已解除锁定！"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/plugins/project/upgrade.dialog.vue
// module id = 346
// module chunks = 3